import { Component, Input, HostBinding, ViewChild } from '@angular/core';
import {
  Conference,
  ConferenceKeys,
  Constants,
  DX_USD_CURRENCY_FORMAT,
  Entity,
  EntityPermissionActivityKeys,
} from 'ag-common-lib/public-api';
import { CONFERENCES_TITLE_LIST } from '../../../config/conferences.config';
import { Excursion, ExcursionKeys } from 'ag-common-lib/lib/models/registration/excursion.model';
import { ExcursionModalComponent } from '../../excursion-modal/excursion-modal.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { ConferenceService } from 'ag-common-svc/public-api';
import { RowRemovingEvent } from 'devextreme/ui/data_grid';
import { BaseModelKeys } from 'ag-common-lib/lib/models/base.model';
import { set } from 'lodash';
import { ChairmanExtensionConfigurationKeys } from 'ag-common-lib/lib/models/registration/conference-chairman-extension';
import { ExcursionModalAction } from '../../excursion-modal/excursion-modal.model';
@Component({
  selector: 'ag-crm-conference-excursions-form',
  templateUrl: './conference-excursions-form.component.html',
  styleUrls: ['./conference-excursions-form.component.scss'],
})
export class ConferenceExcursionsFormComponent {
  @HostBinding('class') className = 'conference-excursions-form';
  @ViewChild('conferenceModalRef') excursionModalComponent: ExcursionModalComponent;
  @ViewChild('excursionsGridTmp') excursionsGridComponent: DxDataGridComponent;
  @Input() conference: Conference;
  @Input() validationGroup: string;
  @Input() isReadonlyMode: boolean = false;

  protected readonly ConferenceKeys = ConferenceKeys;
  protected readonly ExcursionKeys = ExcursionKeys;
  protected readonly titleList = CONFERENCES_TITLE_LIST;
  protected readonly dateFormat: string = Constants.DISPLAY_DATE_FORMAT;
  protected readonly DX_USD_CURRENCY_FORMAT = DX_USD_CURRENCY_FORMAT;
  protected readonly BaseModelKeys = BaseModelKeys;
  protected readonly Entity = Entity;
  protected readonly EntityPermissionActivityKeys = EntityPermissionActivityKeys;
  protected readonly ChairmanExtensionConfigurationKeys = ChairmanExtensionConfigurationKeys;
  protected readonly ExcursionModalAction = ExcursionModalAction;

  constructor(private conferenceService: ConferenceService) {}

  protected onRowRemoving = (e: RowRemovingEvent, items: Excursion[], path: string) => {
    const data: Partial<Conference> = {};
    const activities = [];

    items?.forEach(excursion => {
      if (e.key !== excursion) {
        const activity = Object.assign({}, excursion);
        activities.push(activity);
      }
    });

    set(data, path, activities);

    const saveChanges = async () => {
      const conferenceDbId = this.conference?.[BaseModelKeys.dbId];
      if (!conferenceDbId) {
        set(this.conference, path, activities);
        return false;
      }

      return this.conferenceService.updateFields(conferenceDbId, data).then(() => {
        items.length = 0;
        items.push(...activities);

        return false;
      });
    };

    e.cancel = saveChanges();
  };
}
